export class AccountRequestAddress {
    public street: string;
    public city: string;
    public state: string;
    public postalCode: string;
    public zipCode: string;
    public name: string;
    public streetLine1: string;
    public streetLine2: string;
    public streetLine3: string;
    public streetLine4: string;
    public countryCode: string;
    constructor(obj?: {
       street?: string;
       city?: string;
       state?: string;
       postalCode?: string;
       zipCode?: string;
       name?: string;
       streetLine1?: string;
       streetLine2?: string;
       streetLine3?: string;
       streetLine4?: string;
       countryCode?: string;
    }) {
        if (obj != null) {
            this.street = typeof obj.street === 'undefined' ? this.street : obj.street;
            this.city = typeof obj.city === 'undefined' ? this.city : obj.city;
            this.state = typeof obj.state === 'undefined' ? this.state : obj.state;
            this.postalCode = typeof obj.postalCode === 'undefined' ? this.postalCode : obj.postalCode;
            this.zipCode = typeof obj.zipCode === 'undefined' ? this.zipCode : obj.zipCode;
            this.name = typeof obj.name === 'undefined' ? this.name : obj.name;
            this.streetLine1 = typeof obj.streetLine1 === 'undefined' ? this.streetLine1 : obj.streetLine1;
            this.streetLine2 = typeof obj.streetLine2 === 'undefined' ? this.streetLine2 : obj.streetLine2;
            this.streetLine3 = typeof obj.streetLine3 === 'undefined' ? this.streetLine3 : obj.streetLine3;
            this.streetLine4 = typeof obj.streetLine4 === 'undefined' ? this.streetLine4 : obj.streetLine4;
            this.countryCode = typeof obj.countryCode === 'undefined' ? this.countryCode : obj.countryCode;
        }
    }
}
